import { render, staticRenderFns } from "./FullScreenGasBizTime.vue?vue&type=template&id=285a80f4&scoped=true&"
import script from "./FullScreenGasBizTime.vue?vue&type=script&lang=js&"
export * from "./FullScreenGasBizTime.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenGasBizTime.vue?vue&type=style&index=0&id=285a80f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a80f4",
  null
  
)

export default component.exports